import { render, staticRenderFns } from "./viewJURIS.vue?vue&type=template&id=5fcbdbe5&scoped=true"
import script from "./viewJURIS.vue?vue&type=script&lang=js"
export * from "./viewJURIS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcbdbe5",
  null
  
)

export default component.exports